import { Stack } from '@mui/material';

import { Loader } from 'components/simple';

const FullScreenLoader = () => (
  <Stack width="100%" height="100vh" justifyContent="center" alignItems="center">
    <Loader />
  </Stack>
);

export default FullScreenLoader;
